import { render } from "./property-info.vue?vue&type=template&id=126d55f8&scoped=true&lang=pug"
import script from "./property-info.vue?vue&type=script&lang=js"
export * from "./property-info.vue?vue&type=script&lang=js"

import "./property-info.vue?vue&type=style&index=0&id=126d55f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126d55f8"]])

export default __exports__